import type { Components } from '@mui/material/styles';

export default function MuiStepConnector(): Components['MuiStepConnector'] {
  return {};
}
